/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CategoryModel } from '../../models/category-model';

export interface CategoryIdGet$Plain$Params {
  id: string;
}

export function categoryIdGet$Plain(http: HttpClient, rootUrl: string, params: CategoryIdGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<CategoryModel>> {
  const rb = new RequestBuilder(rootUrl, categoryIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<CategoryModel>;
    })
  );
}

categoryIdGet$Plain.PATH = '/Category/{id}';
